export default __webpack_public_path__ + "static/media/slicer.5069cd3f.svg";